"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _util = require("./util.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ListTable = function ListTable(props) {
  var renderListTable = function renderListTable(chart) {
    var labelHeader = props.labelHeader,
      valueHeader = props.valueHeader;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].listTableWrap
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: _style["default"].listTable
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
      className: _style["default"].barBelow
    }, /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableValue
    }, valueHeader), /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableLabel
    }, labelHeader))), /*#__PURE__*/_react["default"].createElement("tbody", null, renderListTableRows(chart))));
  };
  var getListTableData = function getListTableData() {
    var data = props.data,
      ignoreLabels = props.ignoreLabels,
      ignoreValues = props.ignoreValues,
      labelPath = props.labelPath,
      valuePath = props.valuePath;
    return data.filter(function (row) {
      var rowLabel = (0, _util.dotIndex)(labelPath, row);
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      return !ignoreLabels.includes(rowLabel) && !ignoreValues.includes(rowValue);
    }).map(function (row) {
      return {
        label: (0, _util.dotIndex)(labelPath, row),
        value: (0, _util.dotIndex)(valuePath, row)
      };
    });
  };
  var renderListTableRows = function renderListTableRows() {
    var data = getListTableData();
    return data.map(function (row, index) {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableValue
      }, row.value), /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableLabel
      }, row.label));
    });
  };
  return renderListTable();
};
ListTable.propTypes = {
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  ignoreLabels: _propTypes["default"].array,
  ignoreValues: _propTypes["default"].array,
  labelHeader: _propTypes["default"].string,
  valueHeader: _propTypes["default"].string
};
ListTable.defaultProps = {
  labelPath: 'value',
  valuePath: 'valueCount',
  ignoreLabels: [],
  ignoreValues: [],
  labelHeader: 'Answer',
  valueHeader: '#'
};
var _default = exports["default"] = ListTable;